<template>
  <div id="canvas-holder" style="width:400px; text-align:center">
    <canvas id="chart-area" height="250"></canvas>
  </div>
</template>
<script>
import { FunnelChart } from "chartjs-funnel";

export default {
  extends: FunnelChart,
  name: "funnel",
  components: {
    FunnelChart
  },
  // props : [ "labels", "data" ],
  props: {
    labels: { type: Array },
    dataChart: { type: Array  },
    height: {  type: String  }     
  },
  data: () => ({
    config: {
      type: "funnel",
      data: {
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(175,238,238)",
              "rgb(250,250,210)",
              "rgb(135,206,235)",
              "rgb(152,251,152)",
              "rgb(176,224,230)",
              "rgb(240,230,140)"
            ],
            hoverBackgroundColor: [
              "rgb(175,238,238)",
              "rgb(250,250,210)",
              "rgb(135,206,235)",
              "rgb(152,251,152)",
              "rgb(176,224,230)",
              "rgb(240,230,140)"
            ]
          }
        ],
        labels: ["Red", "Blue", "Yellow"]
      },
      options: {
        responsive: true,
        sort: "desc",
        legend: {
          position: "bottom"
        },
        title: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        }
      }
    }
  }),
  mounted() {
    this.config.data.datasets[0].data = this.$props.dataChart;
    this.config.data.labels = this.$props.labels;

    var ctx = document.getElementById("chart-area").getContext("2d");
    window.myDoughnut = new Chart(ctx, this.config);
  }
};
</script>